//export const  DEFAULT_PATH = "http://localhost:8080"; //development
export const DEFAULT_PATH ="/api"; //prod
